
export enum SymphonyPubDeliverToCd {
	EMS = 'EMS',
	ENSEMBLE = 'Ensemble',
	KAFKA = 'Kafka',
	PUB_SUB = 'PubSub'}

